import { NavLink } from 'react-router-dom'
import { DivContainer } from './styles/Header.styled'

function CreatePostButton() {
	return (
		<NavLink to='/create'>
			<DivContainer>
				<svg
					version='1.1'
					id='Layer_1'
					xmlns='http://www.w3.org/2000/svg'
					xmlnsXlink='http://www.w3.org/1999/xlink'
					x='0px'
					y='0px'
					viewBox='0 0 458.018 458.018'
					xmlSpace='preserve'
				>
					<g>
						<g>
							<g>
								<path
									d='M307.631,425.737h0.002c0,1.551-1.262,2.813-2.814,2.813H36.111c-1.552,0-2.814-1.262-2.814-2.813V32.282     c0-1.552,1.262-2.814,2.814-2.814h268.708c1.552,0,2.814,1.262,2.814,2.814v27.411l29.442-28.412     C336.543,13.943,322.283,0,304.819,0H36.111C18.311,0,3.829,14.481,3.829,32.282v393.455c0,17.799,14.481,32.281,32.281,32.281     h268.708c17.8,0,32.281-14.481,32.281-32.281V287.234l-29.468,29.467V425.737z'
									fill='#087ea4'
								/>
								<path
									d='M55.319,345.509c0,8.137,6.597,14.734,14.734,14.734h51.527c-5.48-8.721-7.756-19.103-6.32-29.467H70.053v-0.001     C61.916,330.775,55.319,337.372,55.319,345.509z'
									fill='#087ea4'
								/>
								<path
									d='M131.134,256.828H70.053c-8.137,0-14.734,6.597-14.734,14.734s6.597,14.734,14.734,14.734h54.697L131.134,256.828z'
									fill='#087ea4'
								/>
								<path
									d='M184.444,182.882H70.053c-8.137,0-14.734,6.597-14.734,14.734c0,8.137,6.597,14.734,14.734,14.734h84.923     L184.444,182.882z'
									fill='#087ea4'
								/>
								<path
									d='M258.39,108.936H70.053c-8.137,0-14.734,6.597-14.734,14.734c0,8.137,6.597,14.734,14.734,14.734h158.869L258.39,108.936     z'
									fill='#087ea4'
								/>
								<path
									d='M436.809,60.304c-24.123-24.836-63.396-24.718-87.457-0.657c-13.58,13.58-174.931,174.931-182.482,182.483     c-1.947,1.946-3.375,4.5-3.982,7.299l-18.249,84.244c-1.045,4.823,0.389,9.944,3.982,13.538c3.569,3.57,8.682,5.034,13.538,3.982     l84.244-18.249c2.772-0.601,5.386-2.066,7.299-3.982l182.482-182.483C460.105,122.56,460.065,84.236,436.809,60.304z      M178.283,317.548l7.686-35.482l27.796,27.796L178.283,317.548z M415.347,125.642L243.283,297.706l-45.158-45.159L370.188,80.483     c12.872-12.873,33.93-12.445,46.257,1.154C427.758,94.102,427.506,113.483,415.347,125.642z'
									fill='#087ea4'
								/>
							</g>
						</g>
					</g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
					<g></g>
				</svg>
			</DivContainer>
		</NavLink>
	)
}

export default CreatePostButton
